import fetch from 'isomorphic-unfetch';

const PATH = '/api/profile/travelers';

const list = async (baseUrl, opts) => {
  const res = await fetch(`${baseUrl}${PATH}`, opts);
  return res.ok ? await res.json() : null;
};

const remove = async travelerId => {
  const res = await fetch(`${PATH}?id=${travelerId}`, {
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  });
  return res;
};

const add = async traveler => {
  const response = await fetch('/api/profile/travelers', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(traveler)
  });

  return response;
};

export default {
  list,
  remove,
  add
};
